import { Injectable } from '@angular/core';
import { MemoryCacheRepository } from './memory-cache.repository';
import { ProductInterface } from '../data';

@Injectable()
export class ProductByOrderTypeCacheRepository extends MemoryCacheRepository<ProductInterface[]> {}
